'use client';
import React from 'react';
import { Box, Typography, Skeleton, useTheme } from '@mui/material';
import { Icon } from '@iconify/react';

const ChatLoader = ({ message = "Processing your query..." }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                bgcolor: 'transparent', // removed white background
                borderRadius: '16px',
                p: 1,
                m: 1,
                width: '100%',
                maxWidth: '100%',
                animation: 'fadeIn 0.5s ease-in-out',
            }}
        >
            {/* AI Avatar */}
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'row' }}>
                <img src="/ethos.svg" alt="Logo" width={20} height={20} />
                <Typography variant="h6" sx={{ fontSize: "15px", fontWeight: "bold", color: "text.primary" }}>
                    Parts360
                </Typography>
            </Box>

            {/* Loading Message */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                <Box
                    sx={{
                        display: 'inline-block',
                        animation: 'pulseIcon 1.2s infinite ease-in-out',
                    }}
                >
                    <Icon icon="svg-spinners:3-dots-bounce" width={22} height={22} color="#2065D1" />
                </Box>
                <Typography variant="body1" sx={{ color: '#2065D1', fontWeight: 500 }}>
                    {message}
                </Typography>
            </Box>

            {/* Skeleton Text Lines */}
            {[100, 85, 70].map((width, idx) => (
                <Skeleton
                    key={idx}
                    variant="text"
                    width={`${width}%`}
                    height={20}
                    sx={{
                        mb: 1,
                        borderRadius: 1,
                        background:
                            'linear-gradient(90deg, rgba(158,158,158,0.06) 25%, rgba(158,158,158,0.2) 50%, rgba(158,158,158,0.06) 75%)',
                        backgroundSize: '200% 100%',
                        animation: 'skeletonWave 1.5s ease-in-out infinite',
                    }}
                />
            ))}

            {/* Skeleton Table Block */}
            <Skeleton
                variant="rectangular"
                width="100%"
                height={150}
                sx={{
                    borderRadius: 2,
                    mt: 2,
                    background:
                        'linear-gradient(90deg, rgba(158,158,158,0.04) 25%, rgba(158,158,158,0.2) 50%, rgba(158,158,158,0.04) 75%)',
                    backgroundSize: '200% 100%',
                    animation: 'skeletonWave 1.8s ease-in-out infinite',
                }}
            />

            {/* Global CSS Animations */}
            <style jsx global>{`
        @keyframes skeletonWave {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes pulseIcon {
          0% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.15);
            opacity: 0.7;
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}</style>
        </Box>
    );
};

export default ChatLoader;
